import coach from './coach'
import center from './center'
import org from './org'
import leader from './leader'
import squad from './squad'
import playerManagement from './player'
import tutorial from './tutorial'
import training from './training'
import trainCamp from './trainCamp'
import trainCampPlan from './trainCampPlan'
import teaching from './teaching'
import media from './media'
import club from './club'
import school from './school'
import siteFacilities from './siteFacilities'
import body from './body'
import scout from './scout'
import performance from './performance';
import expert from './expert'
import plan from './plan'
import pay from './pay'
import record from './record'
import talentSendPlayer from './talentSendPlayer'
import match from './match'
import displayRoutes from './statistics'
import supervision from './supervision'

export const asyncRoutes = [
  {
    path: '/home',
    name: 'Home',
    redirect: '/home/index',
    component: () => import('@/components/layout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'index',
        component: () => import('@/views/home'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/components/layout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'personal',
        component: () => import('@/views/setting/Personal'),
        meta: { requiresAuth: true }
      }
    ]
  },
  coach,
  org,
  playerManagement,
  tutorial,
  training,
  squad,
  leader,
  center,
  trainCamp,
  trainCampPlan,
  teaching,
  media,
  club,
  school,
  siteFacilities,
  body,
  scout,
  performance,
  expert,
  plan,
  pay,
  record,
  talentSendPlayer,
  match,
  supervision,
  ...displayRoutes,
  {
    path: '*',
    redirect: '/login'
  }
]

/* 本路由中注册的路由表信息会全部输出到白名单中，不会检验loginToken存在，不存在权限校验 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login')
  },
  {
    path: '/region_new',
    name: 'RegionNew',
    component: () => import("@/views/login/RegionNew"),
  },
  {
    path: '/talent',
    name: 'talent',
    component: () => import('@/views/CfaTalentOpinion/talentOpinionSubmit')
  },
  {
    path: '/recruitment',
    name: 'Recruitment',
    component: () => import('@/views/recruitment/Recruitment'),
    meta: { requiresAuth: false }
  },
  {
    path: '/recruitmentInfo',
    name: 'RecruitmentInfo',
    component: () => import('@/views/recruitment/RecruitmentInfo'),
    meta: { requiresAuth: false }
  },
  {
    path: '/courseApply',
    name: 'courseApply',
    component: () => import('@/views/recruitment/CourseApply'),
    meta: { requiresAuth: false }
  },
  /* 青少年球队信息收集 */
  {
    path: '/teamInfoColect',
    name: 'TeamInfoColect',
    component: () => import('@/views/tempPage/TeamInfoColect'),
    meta: { requiresAuth: false }
  },
  /* 制作训练课程 */
  {
    path: '/classRequirements',
    name: 'ClassRequirements',
    component: () => import('@/views/tempPage/ClassRequirements'),
    meta: { requiresAuth: false }
  },
  /* 教练员推荐 */
  {
    path: '/coachRecommend',
    name: 'CoachRecommend',
    component: () => import('@/views/tempPage/CoachRecommend'),
    meta: { requiresAuth: false }
  },
  /* 球员推荐 */
  {
    path: '/playerRecommend',
    name: 'PlayerRecommend',
    component: () => import('@/views/tempPage/PlayerRecommend'),
    meta: { requiresAuth: false }
  },
  /* 赛事提交 */
  {
    path: '/youthMatch',
    name: 'YouthMatch',
    component: () => import('@/views/tempPage/YouthMatch'),
    meta: { requiresAuth: false }
  },
  /* 青训总监收集和推荐 */
  {
    path: '/majorDomoRecommend',
    name: 'majorDomoRecommend',
    component: () => import('@/views/tempPage/majorDomoRecommend'),
    meta: { requiresAuth: false }
  },
  /* 急救培训班汇总 */
  {
    path: '/emergencyRecommend',
    name: 'emergencyRecommend',
    component: () => import('@/views/tempPage/emergencyRecommend'),
    meta: { requiresAuth: false }
  },
  /* 线上青训大纲分享会报名 */
  {
    path: '/lineOutlineRecommend',
    name: 'lineOutlineRecommend',
    component: () => import('@/views/tempPage/lineOutlineRecommend'),
    meta: { requiresAuth: false }
  },
  { // 又上传文件 // 以后空白信息就用这个，
    path: '/seminarInfo',
    name: 'SeminarInfo',
    component: () => import('@/views/tempPage/Index'),
    meta: { requiresAuth: false }
  }
]
